/** Availity integration (`fp_configuration.vob_source`). */
export const AVAILITY_VOB_SOURCE_ID = 2;

/** Configuration-service payor list filter (`GET …/payor?vobSource=`). */
export const AVAILITY_VOB_SOURCE_SLUG = 'availity';
